module.exports = __webpack_public_path__ + "static/media/person-circle-outline-white.c4532902.svg";